import type { OrdersTranslations } from './types';

/**
 * Urdu translations for Orders domain
 * Comprehensive translations covering all UI text
 */
export const urTranslations: OrdersTranslations = {
  // Page/Section level
  title: 'آرڈرز',
  subtitle: 'اپنے سیمنٹ آرڈرز کو ٹریک اور منظم کریں',
  overview: 'جائزہ',

  // Actions
  addOrder: 'آرڈر شامل کریں',
  editOrder: 'آرڈر میں ترمیم کریں',
  deleteOrder: 'آرڈر حذف کریں',
  createOrder: 'آرڈر بنائیں',
  newOrder: 'نیا آرڈر',
  cancel: 'آرڈر منسوخ کریں',
  cancelOrder: 'آرڈر منسوخ کریں',
  cancelConfirmTitle: 'آرڈر منسوخ کریں',
  cancelConfirmDescription:
    'کیا آپ واقعی آرڈر {{orderNumber}} منسوخ کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہو سکتا۔',
  cancelSuccessDesc: 'آرڈر {{orderNumber}} منسوخ کر دیا گیا ہے۔',
  cancelError: 'منسوخی ناکام',
  cancelErrorDesc:
    'آرڈر {{orderNumber}} منسوخ نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔',
  orderNumberCopied: 'آرڈر نمبر کاپی ہو گیا',
  copyOrderNumber: 'آرڈر نمبر کاپی کریں',
  joinQueue: 'قطار میں شامل ہوں',
  joiningQueue: 'شامل ہو رہا ہے...',
  queueJoined: 'قطار میں',
  queueJoinError: 'قطار میں شامل نہیں ہو سکے',
  sendSmsToDriver: 'ڈرائیور کو SMS بھیجیں',
  sendingSms: 'بھیجا جا رہا ہے...',
  smsSent: 'SMS بھیج دی گئی',
  smsSentDesc: 'ڈرائیور کو آرڈر لنک کی اطلاع دی گئی۔',
  smsError: 'SMS ناکام',
  smsErrorDesc: 'SMS بھیجنے میں ناکامی ہوئی۔ براہ کرم دوبارہ کوشش کریں۔',
  smsNoDriver: 'اس آرڈر میں کوئی ڈرائیور تفویض نہیں ہے۔',
  downloadPDF: 'آرڈر کی تفصیلات ڈاؤن لوڈ کریں',
  downloadDeliveryNote: 'ڈیلیوری نوٹ ڈاؤن لوڈ کریں',
  previewDeliveryNote: 'ڈیلیوری نوٹ دیکھیں',
  trackOrder: 'آرڈر ٹریک کریں',
  reorder: 'دوبارہ آرڈر کریں',

  // Search and filters
  search: 'آرڈرز تلاش کریں...',
  searchPlaceholder: 'آرڈر نمبر یا SAP سیلز آرڈر # سے تلاش کریں...',
  noItemsFound: 'کوئی آرڈر نہیں ملا',
  noItemsDescription:
    'آپ نے ابھی تک کوئی آرڈر شامل نہیں کیا۔ شروع کرنے کے لیے اپنا پہلا آرڈر شامل کریں۔',
  addFirst: 'اپنا پہلا آرڈر شامل کریں',
  noOrders: 'کوئی آرڈر نہیں ملا',
  noOrdersDescription: 'آپ کے موجودہ فلٹرز سے کوئی آرڈر میل نہیں کھاتے۔',

  // Status labels
  pending: 'زیر التوا',
  processing: 'پروسیسنگ',
  inTransit: 'راستے میں',
  delivered: 'ترسیل شدہ',
  cancelled: 'منسوخ',
  total: 'کل',
  recent: 'حالیہ',
  enRoute: 'راستے میں',

  // Order details
  id: 'آرڈر نمبر',
  sapSalesOrderNumber: 'SAP سیلز آرڈر #',
  orderId: 'آرڈر آئی ڈی',
  orderDetails: 'آرڈر کی تفصیلات',
  amount: 'رقم',
  quantity: 'مقدار',
  schedule: 'شیڈول',
  orderDate: 'آرڈر کی تاریخ',
  deliveryDate: 'ترسیل کی تاریخ',
  processingToDeliveredTime: 'پروسیسنگ سے ترسیل تک وقت',
  loadingTime: 'لوڈنگ کا وقت',
  deliveryAddress: 'ترسیل کا پتہ',
  paymentStatus: 'ادائیگی کی حالت',
  paid: 'ادا شدہ',
  salesOrder: 'سیلز آرڈر',
  viewSalesOrder: 'سیلز آرڈر کی تفصیلات دیکھیں',
  salesOrderCreatedBy: 'سیلز آرڈر بنانے والا',
  product: 'پروڈکٹ',
  driver: 'ڈرائیور',
  factory: 'پلانٹ',
  bags: 'تھیلے',
  tons: 'ٹن',
  kg: 'کلوگرام',
  bulk: 'بلک',
  selectProduct: 'پروڈکٹ منتخب کریں',
  trackingInfo: 'ٹریکنگ کی معلومات',
  driverInfo: 'ڈرائیور کی معلومات',
  notFound: 'آرڈر نہیں ملا',
  orderNotFoundDescription: 'آرڈر نہیں مل سکا',

  // Weighbridge
  shipment: 'شپمنٹ',
  weighbridge: 'وزنی پل',
  weighbridgeGross: 'کل وزن',
  weighbridgeTare: 'خالی وزن',
  weighbridgeNet: 'خالص وزن',
  weighbridgeTickets: 'ٹکٹس',
  weighbridgeTimeline: 'وزنی پل ٹائم لائن',

  // PDF
  downloadingPDF: 'PDF ڈاؤن لوڈ ہو رہا ہے',
  downloadingPDFDesc: 'آرڈر {{orderNumber}} کی PDF بن رہی ہے...',
  pdfDownloaded: 'PDF ڈاؤن لوڈ ہو گئی',
  pdfDownloadedDesc: 'آرڈر {{orderNumber}} کی PDF ڈاؤن لوڈ ہو گئی ہے',
  pdfDownloadError: 'ڈاؤن لوڈ ناکام',
  pdfDownloadErrorDesc:
    'آرڈر کی PDF ڈاؤن لوڈ نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔',
  downloadingDeliveryNote: 'ڈیلیوری نوٹ ڈاؤن لوڈ ہو رہا ہے',
  downloadingDeliveryNoteDesc: 'آرڈر {{orderNumber}} کے لیے ڈیلیوری نوٹ تیار ہو رہا ہے...',
  deliveryNoteDownloaded: 'ڈیلیوری نوٹ ڈاؤن لوڈ ہو گیا',
  deliveryNoteDownloadedDesc: 'آرڈر {{orderNumber}} کا ڈیلیوری نوٹ ڈاؤن لوڈ ہو گیا ہے',
  deliveryNoteDownloadError: 'ڈیلیوری نوٹ ڈاؤن لوڈ ناکام',
  deliveryNoteDownloadErrorDesc:
    'ڈیلیوری نوٹ ڈاؤن لوڈ نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔',
  pdfPreviewTitle: 'آرڈر PDF',
  pdfPreviewSubtitle: 'ایپ کے اندر محفوظ پیش نظارہ',
  pdfPreviewShare: 'شیئر کریں',
  pdfPreviewRetry: 'دوبارہ کوشش کریں',
  pdfPreviewFileName: 'فائل کا نام',
  pdfPreviewFileSize: 'فائل کا حجم',
  pdfPreviewDismiss: 'منسوخ',
  pdfPreviewBadge: 'PDF',
  pdfPreviewReady: 'PDF تیار ہے',
  pdfPreviewReadyDesc: 'آپ اس آرڈر PDF کا جائزہ لے کر شیئر کر سکتے ہیں۔',
  pdfPreviewUnavailableTitle: 'پیش نظارہ دستیاب نہیں',
  pdfPreviewUnavailableDesc:
    'یہ ڈیوائس ایپ کے اندر PDF نہیں دکھا سکتی۔ فائل کھولنے کے لیے شیئر استعمال کریں۔',
  pdfShareErrorDesc: 'آرڈر PDF شیئر نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔',
  pdfShareUnavailableDesc: 'اس ڈیوائس پر شیئر دستیاب نہیں۔',
  deliveryNotePreviewTitle: 'ڈیلیوری نوٹ',
  deliveryNotePreviewSubtitle: 'اس ڈیوائس پر دیکھیں اور شیئر کریں',
  deliveryNotePreviewDocumentName: 'دستاویز کا نام',
  deliveryNotePreviewDocumentSize: 'دستاویز کا سائز',
  deliveryNotePreviewBadge: 'ترسیل',
  deliveryNotePreviewReady: 'ڈیلیوری نوٹ تیار ہے',
  deliveryNotePreviewReadyDesc: 'آپ ڈیلیوری نوٹ کا جائزہ لے کر شیئر کر سکتے ہیں۔',
  deliveryNoteShareErrorDesc: 'ڈیلیوری نوٹ شیئر نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔',
  pdfFileSizeUnitB: 'B',
  pdfFileSizeUnitKB: 'KB',
  pdfFileSizeUnitMB: 'MB',
  pdfFileSizeUnitGB: 'GB',

  // Filters
  filterByStatus: 'حالت کے مطابق فلٹر کریں',
  filterByProduct: 'پروڈکٹ کے مطابق فلٹر کریں',
  filterByAmount: 'رقم کے مطابق فلٹر کریں',
  filterByAddress: 'پتے کے مطابق فلٹر کریں',
  filterByDate: 'تاریخ کے مطابق فلٹر کریں',
  filterByOrderDate: 'آرڈر کی تاریخ کے مطابق فلٹر کریں',
  filterByDeliveryDate: 'ترسیل کی تاریخ کے مطابق فلٹر کریں',
  filterByLP: 'لائسنس پلیٹ کے مطابق فلٹر کریں',
  lpPlaceholder: 'لائسنس پلیٹ درج کریں',
  filterByDriver: 'ڈرائیور کے مطابق فلٹر کریں',
  filterBySubCustomer: 'گاہک کے مطابق فلٹر کریں',
  unknownSubCustomerOnly: 'صرف نامعلوم گاہک',
  subCustomerPresenceAll: 'تمام آرڈرز',
  subCustomerPresenceAssigned: 'گاہک کے ساتھ',
  subCustomerPresenceNone: 'بغیر گاہک',
  specificSubCustomers: 'مخصوص گاہک',
  driverPlaceholder: 'ڈرائیور کا نام درج کریں',
  driverNameExamplePlaceholder: 'مثلاً: احمد',
  filterByQuantity: 'مقدار کے مطابق فلٹر کریں',
  quantityFilterHint: 'ہر آرڈر کی اپنی اکائی میں (تھیلے، ٹن یا کلوگرام)',
  filterByLoadingTime: 'لوڈنگ کے وقت کے مطابق فلٹر کریں',
  filterByProcessingTime: 'پروسیسنگ کے وقت کے مطابق فلٹر کریں',
  durationFilterHint: 'وہ آرڈرز خارج ہیں جن کا دورانیہ ریکارڈ نہیں ہوا',
  minutesUnit: 'منٹ',
  filterDescription:
    'ان فلٹرز کا استعمال کرتے ہوئے اپنی آرڈرز کی فہرست کو بہتر بنائیں',
  searchProducts: 'پروڈکٹس تلاش کریں...',
  searchAddresses: 'پتے تلاش کریں...',
  minAmount: 'کم از کم رقم',
  maxAmount: 'زیادہ سے زیادہ رقم',
  noLimit: 'کوئی حد نہیں',
  selectDateRange: 'تاریخ کی حد منتخب کریں',
  selectStatus: 'حالت منتخب کریں',

  // Sort options
  sortByDate: 'تاریخ',
  sortNewest: 'سب سے نئے پہلے',
  sortOldest: 'سب سے پرانے پہلے',
  sortByOrderNumber: 'آرڈر نمبر',
  sortByOrderNumberAsc: 'آرڈر # (ا-ی)',
  sortByOrderNumberDesc: 'آرڈر # (ی-ا)',
  sortByOrderDate: 'آرڈر کی تاریخ',
  sortByOrderDateAsc: 'آرڈر کی تاریخ (قریب ترین)',
  sortByOrderDateDesc: 'آرڈر کی تاریخ (دور ترین)',
  sortByDeliveryDate: 'ترسیل کی تاریخ',
  sortByDeliveryDateAsc: 'ترسیل (قریب ترین)',
  sortByDeliveryDateDesc: 'ترسیل (دور ترین)',
  sortByAmount: 'رقم',
  sortByAmountAsc: 'رقم (کم سے زیادہ)',
  sortByAmountDesc: 'رقم (زیادہ سے کم)',
  sortByStatus: 'حالت',
  sortByStatusAsc: 'حالت (ا-ی)',
  sortByStatusDesc: 'حالت (ی-ا)',
  sortByProduct: 'پروڈکٹ',
  sortByProductAsc: 'پروڈکٹ (ا-ی)',
  sortByProductDesc: 'پروڈکٹ (ی-ا)',
  sortByTenant: 'کرایہ دار',
  sortByTenantAsc: 'کرایہ دار (ا-ی)',
  sortByTenantDesc: 'کرایہ دار (ی-ا)',

  // New order modal
  addressPlaceholder: 'ترسیل کا پتہ منتخب کریں',
  notes: 'نوٹس',
  notesPlaceholder: 'خاص ہدایات...',
  estimatedTotal: 'تخمینی کل',

  // Form section
  form: {
    name: 'آرڈر کا نام',
    namePlaceholder: 'آرڈر کا نام درج کریں',
    status: 'حالت',
    validation: {
      nameRequired: 'آرڈر کا نام ضروری ہے',
    },
  },

  // Status (kept for compatibility)
  status: {
    active: 'فعال',
    inactive: 'غیر فعال',
  },

  // Toast messages
  messages: {
    createSuccess: 'آرڈر کامیابی سے بنایا گیا',
    updateSuccess: 'آرڈر کامیابی سے اپ ڈیٹ ہوا',
    deleteSuccess: 'آرڈر کامیابی سے حذف ہوا',
    deleteConfirm: 'کیا آپ واقعی اس آرڈر کو حذف کرنا چاہتے ہیں؟',
  },

  // Table headers
  table: {
    name: 'نام',
    status: 'حالت',
    factory: 'پلانٹ',
    product: 'پروڈکٹ',
    driver: 'ڈرائیور',
    quantity: 'مقدار',
    orderDate: 'آرڈر کی تاریخ',
    deliveryDate: 'ترسیل کی تاریخ',
    amount: 'رقم',
    actions: 'اعمال',
  },

  // Table column labels
  configureColumns: 'کالمز',
  selectVisibleColumns: 'نمایاں کالم منتخب کریں',
  actions: 'اعمال',
  cancelReasonUserRequested: 'صارف نے منسوخی کی درخواست کی',

  // Top-level convenience keys
  name: 'نام',
  namePlaceholder: 'آرڈر کا نام درج کریں',
  statusLabel: 'حالت',
  nameRequired: 'آرڈر کا نام ضروری ہے',
  active: 'فعال',
  inactive: 'غیر فعال',
  createSuccess: 'آرڈر کامیابی سے بنایا گیا',
  updateSuccess: 'آرڈر کامیابی سے اپ ڈیٹ ہوا',
  deleteSuccess: 'آرڈر کامیابی سے حذف ہوا',
  deleteConfirm: 'کیا آپ واقعی اس آرڈر کو حذف کرنا چاہتے ہیں؟',

  // Bulk actions
  bulkActions: {
    selected: 'منتخب',
    selectAllOnPage: 'اس صفحے پر سب منتخب کریں',
    deselectAllOnPage: 'اس صفحے پر سب غیر منتخب کریں',
    selectAllOrders: 'تمام {{count}} آرڈرز منتخب کریں',
    clearSelection: 'انتخاب صاف کریں',
    downloadPDF: 'PDF ڈاؤن لوڈ کریں',
    downloadingPDFs: 'PDFs ڈاؤن لوڈ ہو رہی ہیں',
    preparingPDFs: '{{count}} آرڈرز کی PDF تیار ہو رہی ہے...',
    pdfsDownloaded: 'PDFs ڈاؤن لوڈ ہو گئیں',
    pdfsDownloadedDesc: '{{count}} آرڈرز کی PDF کامیابی سے ڈاؤن لوڈ ہو گئی',
    pdfDownloadErrorDesc:
      'آرڈرز کی PDF ڈاؤن لوڈ نہیں ہو سکیں۔ براہ کرم دوبارہ کوشش کریں۔',
    maxOrdersExceeded:
      'ایک وقت میں زیادہ سے زیادہ 25 آرڈرز ڈاؤن لوڈ ہو سکتے ہیں',
    cancelSelected: 'منتخب آرڈرز منسوخ کریں',
    cancelSelectedSuccess: '{{count}} منتخب آرڈرز منسوخ کر دیے گئے',
    cancelSelectedPartialTitle: 'بلک منسوخی مسائل کے ساتھ مکمل ہوئی',
    cancelSelectedPartialDesc:
      '{{successCount}} آرڈرز منسوخ ہوئے، {{failureCount}} ناکام',
    cancelSelectedError: 'بلک منسوخی ناکام',
    cancelSelectedErrorDesc:
      'منتخب آرڈرز منسوخ نہیں ہو سکے۔ براہ کرم دوبارہ کوشش کریں۔',
    selectAllAnyStatus: 'اس صفحے پر سب منتخب کریں (کوئی بھی حیثیت)',
    deselectAllAnyStatus: 'اس صفحے پر سب غیر منتخب کریں',
    forceStatusUpdate: 'زبردستی حیثیت اپ ڈیٹ',
    forceStatusUpdating: 'اپ ڈیٹ ہو رہا ہے...',
    forceStatusUpdateSuccess: '{{count}} آرڈرز کو {{status}} پر زبردستی اپ ڈیٹ کیا گیا',
    forceStatusUpdatePartialTitle: 'زبردستی اپ ڈیٹ مسائل کے ساتھ مکمل ہوئی',
    forceStatusUpdatePartialDesc: '{{successCount}} آرڈرز اپ ڈیٹ ہوئے، {{failureCount}} ناکام',
    forceStatusUpdateError: 'زبردستی اپ ڈیٹ ناکام',
    forceStatusUpdateErrorDesc: 'آرڈر کی حیثیتیں زبردستی اپ ڈیٹ نہیں ہو سکیں۔ براہ کرم دوبارہ کوشش کریں۔',
  },

  forceStatusUpdateModal: {
    title: 'زبردستی حیثیت اپ ڈیٹ',
    description: 'یہ اقدام آرڈر کی معمول کی حیثیت تبدیلیوں کو نظرانداز کرتا ہے۔ یہ مکمل آڈٹ تفصیلات کے ساتھ ریکارڈ کیا جائے گا۔ صرف مجاز ہنگامی یا تصحیح کے حالات میں استعمال کریں۔',
    ordersSummary: '{{count}} آرڈر(ز) منتخب',
    targetStatusLabel: 'ہدف حیثیت',
    targetStatusPlaceholder: 'ہدف حیثیت منتخب کریں',
    reasonLabel: 'وجہ (کم از کم 20 حروف)',
    reasonPlaceholder: 'تفصیل سے بیان کریں کہ یہ زبردستی حیثیت تبدیلی کیوں ضروری ہے، کس واقعہ یا مسئلے نے اسے جنم دیا، اور کس نے اجازت دی...',
    reasonMinLength: 'وجہ کم از کم 20 حروف ہونی چاہیے',
    incidentRefLabel: 'واقعہ / ٹکٹ حوالہ (اختیاری)',
    incidentRefPlaceholder: 'مثلاً INC-1234، JIRA-567',
    affectedOpsNoteLabel: 'آپریشنل نوٹس (اختیاری)',
    affectedOpsNotePlaceholder: 'اس اوورائیڈ کے بارے میں آپریشنز ٹیم کے لیے کوئی نوٹس...',
    acknowledgeLabel: 'میں تصدیق کرتا/کرتی ہوں کہ یہ ایک مجاز اوورائیڈ ہے اور میں اس اقدام کی مکمل ذمہ داری قبول کرتا/کرتی ہوں',
    confirmTextLabel: 'تصدیق کے لیے "FORCE UPDATE" ٹائپ کریں',
    confirmTextPlaceholder: 'FORCE UPDATE',
    confirmTextHint: 'سبمٹ بٹن فعال کرنے کے لیے FORCE UPDATE (بڑے حروف میں) ٹائپ کرنا لازمی ہے',
    confirmTextMismatch: 'آپ کو بالکل "FORCE UPDATE" ٹائپ کرنا ہوگا',
    submitButton: '{{count}} آرڈر(ز) زبردستی اپ ڈیٹ کریں',
    submittingButton: 'اپ ڈیٹ ہو رہا ہے...',
    cancelButton: 'منسوخ کریں',
    warningTitle: 'ناقابل واپسی اقدام',
    warningDesc: 'یہ فوری طور پر {{count}} آرڈر(ز) کی حیثیت تبدیل کر دے گا۔ یہ اقدام مکمل طور پر ریکارڈ اور قابل آڈٹ ہے۔',
    statusPlanned: 'منصوبہ بند (زیر التواء)',
    statusProcessing: 'پروسیسنگ',
    statusDelivered: 'ڈیلیور ہو گیا',
    statusCanceled: 'منسوخ',
    statusFailed: 'ناکام',
    currentStatusSummaryLabel: 'منتخب آرڈرز کی موجودہ حیثیتیں',
  },

  // Timeline tab
  timeline: 'ٹائم لائن',
  timelineEmpty: 'ابھی تک کوئی واقعہ نہیں',
  timelineEmptyDesc: 'آرڈر کی پیش رفت کے ساتھ واقعات یہاں ظاہر ہوں گے',
  timelineEntityOrder: 'آرڈر',
  timelineEntityShipment: 'شپمنٹ',
  timelineEntityWeighbridge: 'وے برج',
  timelineEntityTransaction: 'لین دین',
  timelineEntityWeightCorrection: 'وزن کی تصحیح',
  timelineEntityQueueEntry: 'قیو انٹری',
  timelineEntitySalesOrder: 'سیلز آرڈر',
  timelineEntityTenant: 'ٹیننٹ',
  timelineEntityUser: 'صارف',
  timelineEntityCustomerAccount: 'کسٹمر اکاؤنٹ',
  timelineEntityVariant: 'ویریئنٹ',
  timelineEntitySku: 'SKU',
  timelineEntityCategory: 'کیٹیگری',
  timelineEntityLoadingLocation: 'لوڈنگ مقام',
  timelineActionCreated: 'بنایا گیا',
  timelineActionUpdated: 'اپ ڈیٹ کیا گیا',
  timelineActionDeleted: 'حذف کیا گیا',
  timelineActionStatusChanged: 'حالت تبدیل',
  timelineActionResourceAssigned: 'وسیلہ تفویض',
  timelineActionResourceChanged: 'وسیلہ تبدیل',
  timelineActionWeighed: 'وزن کیا گیا',
  timelineActionWeightCorrected: 'وزن درست کیا گیا',
  timelineActionGateOpened: 'گیٹ کھولا گیا',
  timelineActionWeighbridgeTriggered: 'وے برج شروع کیا گیا',
  timelineActionKioskScanFailed: 'اسکین ناکام',
  timelineActionQueuePositionChanged: 'قیو پوزیشن تبدیل',
  timelineActionApproved: 'منظور کیا گیا',
  timelineActionSuspended: 'معطل کیا گیا',
  timelineActionActivated: 'فعال کیا گیا',
  timelineActionBlocked: 'بلاک کیا گیا',
  timelineActionUnblocked: 'بلاک ختم کیا گیا',
  timelineActionPasswordReset: 'پاس ورڈ ری سیٹ',
  timelineActionRoleChanged: 'رول تبدیل',
  timelineActionChannelChanged: 'چینل تبدیل',
  timelineActionGroupChanged: 'گروپ تبدیل',

  // Timeline metadata detail labels
  timelineMetaDriver: 'ڈرائیور',
  timelineMetaVehicle: 'گاڑی',
  timelineMetaTrailer: 'ٹریلر',
  timelineMetaNet: 'خالص',
  timelineMetaFirst: 'پہلا',
  timelineMetaSecond: 'دوسرا',
  timelineMetaChanged: 'تبدیل شدہ',
  timelineMetaReason: 'وجہ',
  timelineMetaMovedBy: 'منتقل کرنے والا',
  timelineMetaNetWeight: 'خالص وزن',
  timelineMetaForcedBy: 'کی طرف سے',
  timelineMetaIncident: 'واقعے کا حوالہ',
  timelineMetaOpsNote: 'آپریشنز نوٹ',
  timelineStatusPlanned: 'منصوبہ بند',
  timelineStatusProcessing: 'پروسیسنگ میں',
  timelineStatusDelivered: 'ڈیلیور ہو گیا',
  timelineStatusCanceled: 'منسوخ',
  timelineStatusFailed: 'ناکام',
  timelineStatusPending: 'زیر التواء',
  timelineStatusLoading: 'لوڈ ہو رہا ہے',
  timelineStatusInTransit: 'راستے میں',
  timelineStatusArrived: 'پہنچ گیا',
  timelineStatusCompleted: 'مکمل',
  timelineStatusReady: 'تیار',
  timelineStatusEntered: 'داخل ہوا',
  timelineStatusWaiting: 'انتظار میں',
  timelineStatusExpired: 'میعاد ختم',
  timelineStageFirstWeight: 'پہلا وزن',
  timelineStageSecondWeight: 'دوسرا وزن',
  timelineFieldOrderStatus: 'آرڈر کی حالت',
  timelineFieldShipmentStatus: 'شپمنٹ کی حالت',
  timelineFieldSapSalesOrderNumber: 'SAP سیلز آرڈر نمبر',
  timelineFieldPricingSnapshot: 'قیمت کی سنیپ شاٹ',
  timelineFieldProcessingStartedAt: 'پروسیسنگ شروع ہونے کا وقت',
  timelineFieldQuantity: 'مقدار',
  timelineFieldDeliveryDate: 'ڈیلیوری کی تاریخ',
  timelineFieldCancellationReason: 'منسوخی کی وجہ',

  // Audit log event descriptions
  audit: {
    orderCreated: 'آرڈر #{{orderNumber}} بنایا گیا',
    orderStatusChanged: 'آرڈر #{{orderNumber}}: {{previousStatus}} سے {{newStatus}} تک',
    orderUpdated: 'آرڈر #{{orderNumber}} اپ ڈیٹ ہوا',
    orderDeleted: 'آرڈر #{{orderNumber}} حذف ہوا',
    shipmentCreated: 'شپمنٹ {{shipmentNumber}} بنائی گئی',
    shipmentCreatedForOrder: 'آرڈر #{{orderNumber}} کے لیے شپمنٹ {{shipmentNumber}} بنائی گئی',
    shipmentStatusChanged: 'شپمنٹ {{shipmentNumber}}: {{previousStatus}} سے {{newStatus}} تک',
    shipmentUpdated: 'شپمنٹ {{shipmentNumber}} اپ ڈیٹ ہوئی',
    shipmentDeleted: 'شپمنٹ {{shipmentNumber}} حذف ہوئی',
    shipmentResourceAssigned: '{{resourceName}} کو شپمنٹ {{shipmentNumber}} تفویض کیا گیا',
    shipmentResourceChanged: 'شپمنٹ {{shipmentNumber}} پر وسیلہ تبدیل ہوا',
    weighbridgeTareRecorded: 'تار وزن ریکارڈ: {{tare}}',
    weighbridgeGrossRecorded: 'مجموعی وزن ریکارڈ: {{gross}} — خالص: {{net}}',
    weightCorrected: '{{ticketNumber}} پر {{correctedBy}} نے وزن درست کیا',
    queueTicketIssued: '{{locationLabel}} میں قیو ٹکٹ {{displayNumber}} جاری',
    queueTicketCancelled: 'قیو ٹکٹ {{displayNumber}} منسوخ',
    queueEntryExpired: 'قیو ٹکٹ {{displayNumber}} کی میعاد ختم',
    queuePositionChanged: 'قیو ٹکٹ {{ticketNumber}} پوزیشن {{fromPosition}} سے {{toPosition}} پر منتقل',
    kioskJoinFailed: 'کیوسک اسکین ناکام',
    kioskErrors: {
      noResourceAssigned: 'شپمنٹ کو کوئی وسیلہ تفویض نہیں',
      alreadyInQueue: 'یہ آرڈر پہلے سے قطار میں ہے',
      vehiclePlateAlreadyInQueue: 'یہ گاڑی پہلے سے قطار میں ہے',
      noLoadingLocation: 'کوئی لوڈنگ مقام دستیاب نہیں',
      sapSalesOrderFailed: 'SAP سیلز آرڈر بنانے میں ناکامی۔ دوبارہ کوشش کریں یا سپورٹ سے رابطہ کریں۔',
      noActiveContract: 'کوئی فعال معاہدہ نہیں ملا۔ اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
      insufficientContractBalance: 'معاہدے کا بیلنس ناکافی ہے۔ اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
      noSapMaterialCode: 'مصنوع کی ترتیب میں خرابی۔ اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
    },
    gateOpenedForEntry: 'داخلے کے لیے گیٹ کھولا گیا — {{gateLabel}}',
    gateOpenedForExit: 'خروج کے لیے گیٹ کھولا گیا — {{gateLabel}}',
    weighbridgeFlowTriggered: '{{gateLabel}} گیٹ پر وے برج فلو شروع کیا گیا (مرحلہ: {{weightStageLabel}})',
    queueEntryEnteredFactory: '{{displayNumber}} گیٹ {{gateId}} سے فیکٹری میں داخل ہوا ({{fromStatus}} سے {{toStatus}})',
    queueEntryExitedFactory: '{{displayNumber}} فیکٹری سے باہر نکلا ({{fromStatus}} سے {{toStatus}})',
  },

  errors: {
    cancellationReasonRequired: 'منسوخی کی وجہ ضروری ہے',
    onlyPlannedCanBeCancelled: 'صرف منصوبہ بند آرڈرز منسوخ ہو سکتے ہیں',
    cannotCancelScannedOrder: 'اسکین شدہ آرڈرز منسوخ نہیں کیے جا سکتے',
    cannotCancelProcessing: 'پروسیسنگ شروع ہونے کے بعد آرڈر منسوخ نہیں ہو سکتا',
    missingTenant: 'آرڈر میں ٹیننٹ کی معلومات غائب ہے',
    notFound: 'آرڈر نہیں ملا',
    notPending: 'آرڈر زیرِ التواء نہیں ہے',
    cancelFailed: 'آرڈر منسوخ کرنے میں ناکامی',
    orderNumberRequired: 'آرڈر نمبر درکار ہے',
  },

  export: {
    exportingTitle: 'برآمد ہو رہا ہے...',
    exportingDesc: 'تمام ریکارڈز حاصل کیے جا رہے ہیں',
    exportingSelected: '{{count}} منتخب آرڈر برآمد ہو رہا ہے',
    exportFailedTitle: 'برآمد ناکام',
    exportFailed: 'آرڈرز برآمد نہیں ہو سکے',
    exportForbidden: 'آپ کو آرڈرز برآمد کرنے کی اجازت نہیں ہے، منتظم سے اجازت شامل کرنے کی درخواست کریں',
    emailPromptTitle: 'ایکسپورٹ کس ای میل پر بھیجنی ہے؟',
    emailPromptDescription: 'اس ایکسپورٹ کے لیے ای میل درج کریں۔ چھوٹی ایکسپورٹس جمع کرانے کے بعد فوراً ڈاؤن لوڈ ہو جائیں گی، جبکہ بڑی ایکسپورٹس ای میل کے ذریعے بھیجی جائیں گی۔',
    emailLabel: 'ای میل ایڈریس',
    emailPlaceholder: 'name@example.com',
    emailRequired: 'ای میل درکار ہے',
    emailInvalid: 'براہ کرم درست ای میل درج کریں',
    exportDownloadedTitle: 'ایکسپورٹ ڈاؤن لوڈ ہو گئی',
    exportDownloadedDescription: '{{count}} آرڈرز ڈاؤن لوڈ ہو گئے',
    exportEmailedTitle: 'ایکسپورٹ ای میل کے ذریعے بھیجی جائے گی',
    exportEmailedDescription: 'ہم {{count}} آرڈرز {{email}} پر بھیجیں گے',
  },
  licensePlateExamplePlaceholder: 'مثلاً: 5080-ZZR',
  subCustomer: 'گاہک',
  selectSubCustomer: 'گاہک منتخب کریں',
  changeSubCustomer: 'گاہک تبدیل کریں',
  noSubCustomer: 'کوئی گاہک تفویض نہیں',
  addNewSubCustomer: 'نیا گاہک شامل کریں',
  subCustomerCode: 'کوڈ',
  subCustomerPhone: 'فون',
  sapSync: 'SAP مطابقت',
  sapSyncNoJobs: 'کوئی SAP مطابقت کام نہیں ملا',
  sapSyncNoJobsDescription: 'اس آرڈر کے لیے کوئی SAP مطابقت آپریشن ریکارڈ نہیں کیا گیا۔',

  supportLookup: {
    title: 'آرڈر سپورٹ تلاش',
    subtitle: 'مکمل آرڈر تفصیلات دیکھنے کے لیے آرڈر نمبر یا SAP سیلز آرڈر نمبر سے تلاش کریں',
    searchPlaceholder: 'آرڈر نمبر یا SAP نمبر درج کریں...',
    search: 'تلاش',
    searching: 'تلاش ہو رہی ہے...',
    orderDetails: 'آرڈر تفصیلات',
    warningTitle: 'سپورٹ ٹول — احتیاط سے استعمال کریں',
    warningDescription: 'یہ صفحہ لائیو آرڈر ڈیٹا کی براہ راست ترمیم کی اجازت دیتا ہے جس میں ویبرج ٹکٹ، ڈیلیوری لائنیں اور ٹائم لائن ایونٹس شامل ہیں۔ تمام تبدیلیاں ریکارڈ کی جاتی ہیں اور ناقابل واپسی ہیں۔ صرف آگے بڑھیں اگر آپ اثر کو مکمل طور پر سمجھتے ہیں۔',
    confirmCancel: 'منسوخ',
    confirmConfirm: 'تصدیق',
    btnTriggerSap: 'SAP سیلز آرڈر چلائیں',
    btnTriggering: 'چل رہا ہے...',
    sapSyncConfirmTitle: 'SAP سیلز آرڈر سنک چلائیں؟',
    sapSyncConfirmDescription: 'یہ اس آرڈر کے لیے SAP کو سنک درخواست بھیجے گا۔ کیا آپ آگے بڑھنا چاہتے ہیں؟',
    fieldOrderNumber: 'آرڈر نمبر',
    fieldSapSalesOrder: 'SAP سیلز آرڈر',
    fieldStatus: 'حیثیت',
    fieldQuantity: 'مقدار',
    fieldDeliveryDate: 'ڈیلیوری کی تاریخ',
    fieldProcessingStarted: 'پروسیسنگ شروع',
    fieldTenant: 'کرایہ دار',
    fieldFactory: 'فیکٹری',
    fieldProduct: 'پروڈکٹ',
    fieldCity: 'شہر',
    fieldDropoff: 'ڈراپ آف',
    fieldSubCustomer: 'ذیلی گاہک',
    fieldSalesOrder: 'سیلز آرڈر',
    fieldCreated: 'تخلیق',
    fieldCancellationReason: 'منسوخی کی وجہ',
    sectionShipment: 'شپمنٹ',
    fieldShipmentNumber: 'شپمنٹ نمبر',
    fieldDispatchedAt: 'روانگی کی تاریخ',
    fieldArrivedAt: 'پہنچنے کی تاریخ',
    fieldOrigin: 'اصل',
    fieldDestination: 'منزل',
    fieldHoldReason: 'روکنے کی وجہ',
    fieldHoldAt: 'روکنے کی تاریخ',
    sectionResource: 'وسائل کی تفویض',
    fieldResourceName: 'وسائل کا نام',
    fieldDriver: 'ڈرائیور',
    fieldDriverPhone: 'ڈرائیور فون',
    fieldPowerUnit: 'پاور یونٹ',
    fieldTrailer: 'ٹریلر',
    sectionWeighbridge: 'ویبرج ٹکٹ',
    colTicketNumber: 'ٹکٹ #',
    colType: 'قسم',
    colGross: 'مجموعی',
    colTare: 'تارہ',
    colNet: 'خالص',
    colScale: 'ترازو',
    colMeasuredAt: 'پیمائش کی تاریخ',
    colActions: 'اقدامات',
    weighbridgeConfirmTitle: 'ویبرج ٹکٹ اپ ڈیٹ کریں؟',
    weighbridgeConfirmDescription: 'آپ ویبرج ڈیٹا میں ترمیم کرنے والے ہیں۔ یہ خالص وزن کے حسابات پر اثر ڈالے گا۔ کیا آپ یقینی ہیں؟',
    sectionQueue: 'قطار کا اندراج',
    fieldQueueNumber: 'قطار نمبر',
    fieldLoadingLocation: 'لوڈنگ مقام',
    fieldVehicle: 'گاڑی',
    fieldRequestedAt: 'درخواست کی تاریخ',
    fieldCalledAt: 'بلانے کی تاریخ',
    fieldEnteredFactory: 'فیکٹری میں داخلہ',
    fieldLoadingStarted: 'لوڈنگ شروع',
    fieldLoadingCompleted: 'لوڈنگ مکمل',
    fieldExitedFactory: 'فیکٹری سے خروج',
    fieldEntryGate: 'داخلے کا دروازہ',
    fieldExitGate: 'خروج کا دروازہ',
    sectionDeliveryLines: 'ڈیلیوری لائنیں',
    colDeliveryNumber: 'ڈیلیوری #',
    colDeliveryStatus: 'ڈیلیوری حیثیت',
    colDeliveredQty: 'ڈیلیور شدہ مقدار',
    colLineStatus: 'لائن حیثیت',
    colPackaging: 'پیکیجنگ',
    colCommittedQty: 'متعہد مقدار',
    deliveryConfirmTitle: 'ڈیلیوری لائن اپ ڈیٹ کریں؟',
    deliveryConfirmDescription: 'آپ ڈیلیوری لائن کی مقدار یا حیثیت میں ترمیم کرنے والے ہیں۔ یہ مالی حسابات اور رپورٹنگ پر اثر ڈالے گا۔ کیا آپ یقینی ہیں؟',
    sectionInvoices: 'انوائسز',
    colInvoiceNumber: 'انوائس #',
    colTotal: 'کل',
    colPaid: 'ادا شدہ',
    colSapNumber: 'SAP #',
    colIssueDate: 'اجرا کی تاریخ',
    colDueDate: 'واجب الادا تاریخ',
    sectionSapSyncJobs: 'SAP سنک جابز',
    colDirection: 'سمت',
    colOperation: 'آپریشن',
    colError: 'غلطی',
    colRetries: 'دوبارہ کوششیں',
    colCreated: 'تخلیق',
    sectionTimeline: 'آرڈر ٹائم لائن',
    placeholderAction: 'اقدام',
    placeholderDescription: 'وضاحت',
    eventConfirmTitle: 'ایونٹ اپ ڈیٹ کریں؟',
    eventConfirmDescription: 'آپ اس آرڈر کے ٹائم لائن ایونٹ میں ترمیم کرنے والے ہیں۔ کیا آپ یقینی ہیں؟',
    deleteEventConfirmTitle: 'ایونٹ حذف کریں؟',
    deleteEventConfirmDescription: 'یہ آرڈر ٹائم لائن سے ایونٹ کو مستقل طور پر ہٹا دے گا۔ یہ اقدام واپس نہیں کیا جا سکتا۔',
    btnSave: 'محفوظ کریں',
    btnCancel: 'منسوخ',
    btnEdit: 'ترمیم',
    btnDelete: 'حذف',
  },
  offlineEntry: {
    title: 'آف لائن آرڈر اندراج',
    subtitle: 'فیکٹری آف لائن ہونے کے دوران لیے گئے آرڈرز کا ڈیٹا مکمل کریں۔ وزن دستی طور پر درج کریں یا شیٹ اپ لوڈ کریں۔',
    tabManual: 'دستی اندراج',
    tabUpload: 'شیٹ اپ لوڈ',
    weightUnitHint: 'وزن کلوگرام (kg) میں ہیں',
    colOrderNumber: 'آرڈر نمبر',
    colFirstWeight: 'پہلا وزن',
    colSecondWeight: 'دوسرا وزن',
    colDeliveryDate: 'ڈیلیوری تاریخ',
    colStatus: 'حیثیت',
    colActions: 'اقدامات',
    addRow: 'قطار شامل کریں',
    removeRow: 'ہٹائیں',
    submit: 'جمع کرائیں',
    submitting: 'جمع ہو رہا ہے…',
    clear: 'صاف کریں',
    downloadResults: 'نتائج ڈاؤن لوڈ کریں',
    dropzone: 'یہاں Excel یا CSV فائل ڈراپ کریں',
    dropzoneHint: 'کالم: orderNumber، firstWeight، secondWeight، deliveryDate',
    browseFile: 'فائل منتخب کریں',
    parseError: 'فائل نہیں پڑھی جا سکی۔ فارمیٹ اور کالم چیک کریں۔',
    rowsLoaded: 'قطاریں لوڈ ہوئیں',
    summary: '{{ok}} کامیاب، {{failed}} ناکام',
    statusOk: 'ٹھیک',
    statusFailed: 'ناکام',
    empty: 'ابھی کوئی قطار نہیں۔ قطار شامل کریں یا شیٹ اپ لوڈ کریں۔',
    submitError: 'جمع کرانا ناکام۔ دوبارہ کوشش کریں۔',
    orderNumberRequired: 'آرڈر نمبر ضروری ہے',
  },
};
